const shape = {
  borderRadius: 4
};
export default shape;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/createTheme/shape.js
// module id = 727
// module chunks = 22